// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "app." + "0c8a6c06f0acdc9e4cd1" + ".css";
};